<template>
  <div
    v-if="value && value.length"
    ref="listItems"
    class="locator-store-list b2b-scroll-list flex-auto m-0"
    :class="{'opacity-75': isLoading}"
  >
    <div
      v-for="(store, index) in value"
      :key="`store-${store.id}`"
      :qaid="`store-locator-list__store${index}`"
      @mouseover="hoverIndex = index"
      @mouseout="hoverIndex = -1"
    >
      <locator-store-card
        :base-properties="baseProperties"
        :pin-hovered="pinHoverId == index"
        :value="store"
        @store-clicked="storeClicked"
      />
    </div>
  </div>

  <div v-else class="flex flex-auto align-center items-center">
    <div v-if="displayEmptyMessage && !isLoading" class="w-1/2" qaid="store-locator-list__empty">
      <div class="text-center my-4" qaid="store-locator__store-list__no-records">
        <img :src="noRecordsImageUrl" class="mb-2" />
        <p v-html="bp('storeFinderEmpty')"></p>
      </div>
    </div>
    <trek-loading v-else-if="isLoading" :is-loading="isLoading" />
  </div>
</template>

<script>
import LocatorStoreCard from '@/components/locator/components/LocatorStoreCard';
import {Scroll} from '@/utils/scroll';
import TrekLoading from '@/components/TrekLoading';

export default {
  name: 'LocatorStoreList',
  components: {LocatorStoreCard, TrekLoading},
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    displayEmptyMessage: {
      type: Boolean,
      default: true,
    },
    pinHoverId: {
      type: Number,
      default: -1,
    },
    page: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      hoverIndex: -1,
    };
  },
  computed: {
    noRecordsImageUrl() {
      return `${ACC.config.azureCdnImagesUrl}/svg/empty_state_clouds.svg`;
    },
  },

  watch: {
    hoverIndex(index) {
      this.$emit('card-hover', index);
    },
    value() {
      Scroll.toElementTop(this.$refs.listItems);
    },
  },

  methods: {
    storeClicked(storeId, distance) {
      this.$emit('store-clicked', storeId, distance);
    },
  },
};
</script>
